<h2 style="margin:5px 0 10px 0;"> Create a New Consumer Type </h2>
<form [formGroup]="form" novalidate (ngSubmit)="OnSubmit()">
  <table cellspacing="2" class="attribute-full-width">
    <tr>
      <td>
        <mat-form-field>
          <input
            [attr.data-testid]="'consumer_type_name_text'"
            formControlName="name"
            matInput
            [pattern]="spaceValidatorPattern"
            placeholder="Name"
            required
            />
          @if (form.controls['name'].invalid) {
            <mat-error>
              Please enter a Name
            </mat-error>
          }
          @if (form.getError('invalidWhiteSpace', 'name'); as error) {
            <mat-error>
              {{ error }}
            </mat-error>
          }
        </mat-form-field>
      </td>
      <td>
        <mat-form-field>
          <input
            [attr.data-testid]="'consumer_type_tag_text'"
            formControlName="tag"
            matInput
            pattern="^[A-Z_0-9]*$"
            placeholder="Tag"
            required
            (focusout)="findTagExists()"
            >
          @if (form.controls['tag'].invalid && !form.controls['tag'].value) {
            <mat-error>
              Please enter a Standard Tag
            </mat-error>
          }
          @if (form.controls['tag'].errors?.pattern && form.controls['tag'].value) {
            <mat-error>
              Please enter a Valid Standard Tag
            </mat-error>
          }
          @if (form.controls['tag'].errors?.tagExists && form.controls['tag'].touched) {
            <mat-error>
              Tag already exists! Create a new one.
            </mat-error>
          }
        </mat-form-field>
      </td>
    </tr>
  </table>
  <div  style="margin-top: 30px;" class="flex-center-center">
    <button
      [attr.data-testid]="'cancel_button'"
      class="button-color"
      mat-raised-button
      matTooltip="Cancel creating Consumer Type"
      style="margin-right: 60px;"
      type="button"
      (click)="onNoClick()"
      >
      Cancel
    </button>
    <button
      [attr.data-testid]="'save_button'"
      [disabled]="isReadOnly | async" class="button-color"
      mat-raised-button
      matTooltip="Save"
      type="submit"
      >
      Save
    </button>
  </div>
</form>
